import { useMemo } from 'react';
import { usePermissions } from 'permissions';
import type { InvitationSearchOption } from '../types';

export const REMINDER_REGULAR_USER_INVITATION_LIMIT = 9;
export const REMINDER_ADMIN_INVITATION_LIMIT = 49;

type P = {
  alreadyInvitedCount: number;
  invitations: InvitationSearchOption[];
};

export const useReminderInvitationCount = ({ alreadyInvitedCount, invitations }: P) => {
  const { isEventsAdmin } = usePermissions();

  const invitationCount =
    alreadyInvitedCount +
    invitations.reduce(
      (accumulator, invitation) => accumulator + (invitation.type === 'community' ? invitation.membersCount : 1),
      0,
    );
  const invitationLimit = isEventsAdmin({}) ? REMINDER_ADMIN_INVITATION_LIMIT : REMINDER_REGULAR_USER_INVITATION_LIMIT;

  return useMemo(() => ({ invitationCount, invitationLimit }), [invitationCount, invitationLimit]);
};
